/* eslint-disable */
import React, { Component } from 'react';
import {
    Card,
    Row,
    Col,
    Form,
    InputNumber,
    Select,
    Button,
    message,
    Input,
    DatePicker,
    Space
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
import axios from "axios";
import moment from 'moment';

const { Option } = Select;

class UpdateEditBooking extends Component {
    constructor(props) {
        super(props);
        this.state = {
            agents: [],
            hotels: [],
            agentOtherOption: false,
            hotelOtherOption: false,
        };
        this.formRef = React.createRef();
    }

    componentDidMount() {
        this.loadAgents();
        this.loadHotels();
    }

    loadAgents = async () => {
        try {
            const response = await axios.get("https://api.srilankaballooning.com/api/getAgents");
            if (response.data.success) {
                this.setState({ agents: response.data.result });
            } else {
                message.error("Failed to load agents");
            }
        } catch (error) {
            console.error("Error loading agents:", error);
            message.error("Error loading agents");
        }
    };

    loadHotels = async () => {
        try {
            const response = await axios.get("https://api.srilankaballooning.com/api/getHotels");
            if (response.data.success) {
                this.setState({ hotels: response.data.result });
            } else {
                message.error("Failed to load hotels");
            }
        } catch (error) {
            console.error("Error loading hotels:", error);
            message.error("Error loading hotels");
        }
    };

    handleSubmit = async (values) => {
        try {
            const rememberedUser = Cookies.get('rememberedUser');
            const USER_ID = rememberedUser ? JSON.parse(rememberedUser).USER_ID : null;

            // If custom agent was entered, call /api/addAgent
            if (this.state.agentOtherOption && values.AGENT) {
                const agentResponse = await axios.post("https://api.srilankaballooning.com/api/addAgent", {
                    AGENT_NAME: values.AGENT,
                    IS_ACTIVE: 1,
                });
                if (agentResponse.data.success) {
                    message.success("New agent added successfully");
                    // Reload agents list to include the new one
                    this.loadAgents();
                } else {
                    message.error("Failed to add new agent");
                    return;
                }
            }

            // If custom hotel was entered, call /api/addHotel
            if (this.state.hotelOtherOption && values.HOTEL) {
                const hotelResponse = await axios.post("https://api.srilankaballooning.com/api/addHotel", {
                    HOTEL_NAME: values.HOTEL,
                    IS_ACTIVE: 1,
                });
                if (hotelResponse.data.success) {
                    message.success("New hotel added successfully");
                    this.loadHotels();
                } else {
                    message.error("Failed to add new hotel");
                    return;
                }
            }

            const updatedValues = {
                ...values,
                BOOKING_ID: this.props.initialValues.BOOKING_ID,
                DATE: values.DATE ? values.DATE.format("YYYY-MM-DD") : null,
                EDITED_BY: USER_ID,
            };

            const updateBooking = await axios.post('https://api.srilankaballooning.com/api/updateBooking', updatedValues);
            if (updateBooking.data.success) {
                message.success('Booking updated successfully');
                await this.props.onUpdate();
                this.props.onCancel();
            } else {
                message.error('Internal server error');
            }
        } catch (error) {
            console.error('Error updating booking:', error);
            message.error('Internal server error');
        }
    };

    render() {
        const inputStyle = { width: '100%' };
        return (
            <div className="tabled">
                <Row gutter={[16, 16]} justify="left" align="top">
                    <Col xs={24} xl={24}>
                        <Card className="criclebox tablespace mb-24">
                            <Form
                                layout="vertical"
                                onFinish={this.handleSubmit}
                                style={{ margin: '20px' }}
                                ref={this.formRef}
                                initialValues={{
                                    ...this.props.initialValues,
                                    DATE: this.props.initialValues.DATE ? moment(this.props.initialValues.DATE) : null,
                                }}
                            >
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={12} md={12} lg={6}>
                                        <Form.Item
                                            label="Booking Date"
                                            name="DATE"
                                            rules={[{ required: true, message: 'Please select the booking date' }]}
                                        >
                                            <DatePicker style={inputStyle} placeholder="Select booking date" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={6}>
                                        <Form.Item label="Guide" name="AGENT">
                                            {this.state.agentOtherOption ? (
                                                <Space.Compact style={{ width: "100%" }}>
                                                    <Input placeholder="Enter Guide/Agent Name" allowClear />
                                                    <Button
                                                        type="default"
                                                        icon={<CloseOutlined />}
                                                        onClick={() => {
                                                            this.setState({ agentOtherOption: false });
                                                            this.formRef.current.setFieldsValue({ AGENT: "" });
                                                        }}
                                                    />
                                                </Space.Compact>
                                            ) : (
                                                <Select
                                                    style={inputStyle}
                                                    placeholder="Select or add a guide"
                                                    onChange={(value) => {
                                                        if (value === "other") {
                                                            this.setState({ agentOtherOption: true });
                                                            this.formRef.current.setFieldsValue({ AGENT: "" });
                                                        }
                                                    }}
                                                >
                                                    {this.state.agents.map((agent) => (
                                                        <Option key={agent.AGENT_ID} value={agent.AGENT_NAME}>
                                                            {agent.AGENT_NAME}
                                                        </Option>
                                                    ))}
                                                    <Option key="other" value="other">
                                                        Other
                                                    </Option>
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={6}>
                                        <Form.Item label="Tour No" name="TOUR_NO">
                                            <Input style={inputStyle} placeholder="Enter tour number" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={12} md={12} lg={6}>
                                        <Form.Item
                                            label="Passenger Name"
                                            name="PASSENGER_NAME"
                                            rules={[{ required: true, message: 'Please enter the passenger name' }]}
                                        >
                                            <Input style={inputStyle} placeholder="Enter passenger name" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={6}>
                                        <Form.Item label="Contact" name="CONTACT">
                                            <Input style={inputStyle} placeholder="Enter contact details" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={6}>
                                        <Form.Item label="Hotel" name="HOTEL">
                                            {this.state.hotelOtherOption ? (
                                                <Space.Compact style={{ width: "100%" }}>
                                                    <Input placeholder="Enter Hotel Name" allowClear />
                                                    <Button
                                                        type="default"
                                                        icon={<CloseOutlined />}
                                                        onClick={() => {
                                                            this.setState({ hotelOtherOption: false });
                                                            this.formRef.current.setFieldsValue({ HOTEL: "" });
                                                        }}
                                                    />
                                                </Space.Compact>
                                            ) : (
                                                <Select
                                                    style={inputStyle}
                                                    placeholder="Select or add a hotel"
                                                    onChange={(value) => {
                                                        if (value === "other") {
                                                            this.setState({ hotelOtherOption: true });
                                                            this.formRef.current.setFieldsValue({ HOTEL: "" });
                                                        }
                                                    }}
                                                >
                                                    {this.state.hotels.map((hotel) => (
                                                        <Option key={hotel.HOTEL_ID} value={hotel.HOTEL_NAME}>
                                                            {hotel.HOTEL_NAME}
                                                        </Option>
                                                    ))}
                                                    <Option key="other" value="other">
                                                        Other
                                                    </Option>
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={12} lg={6}>
                                        <Form.Item label="Pax No" name="PAX_NO">
                                            <InputNumber style={inputStyle} placeholder="Enter number of passengers" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={24}>
                                        <Form.Item
                                            label="Remarks / Other Information"
                                            name="REMARKS"
                                        >
                                            <Input.TextArea style={inputStyle} rows={4} placeholder="Enter remarks or other information" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24}>
                                        <Form.Item>
                                            <Button type="primary" htmlType="submit">
                                                Update Booking
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default UpdateEditBooking;
